import React from "react";
import type { RouteObject } from "react-router-dom";
import { LoginRequiredWrapper } from "src/pages/wrappers";
import lazyWithRetry from "src/utils/lazy-with-retry";

const CampaignDetailPage = lazyWithRetry(() =>
  import(/* webpackChunkName: "CampaignDetailPage" */ "src/pages/maria").then((module) => ({
    default: module.CampaignDetailPage,
  })),
);

const CampaignDashboardPage = lazyWithRetry(() =>
  import(/* webpackChunkName: "CampaignDashboardPage" */ "src/pages/maria").then((module) => ({
    default: module.CampaignDashboardPage,
  })),
);

const CampaignPage = lazyWithRetry(() =>
  import(/* webpackChunkName: "CampaignPage" */ "src/pages/maria").then((module) => ({
    default: module.CampaignPage,
  })),
);

const CampaignDetailOverview = lazyWithRetry(() =>
  import(/* webpackChunkName: "CampaignDetailOverview" */ "src/pages/maria").then((module) => ({
    default: module.CampaignDetailOverview,
  })),
);

const CampaignRentalPage = lazyWithRetry(() =>
  import(/* webpackChunkName: "CampaignRentalPage" */ "src/pages/maria").then((module) => ({
    default: module.CampaignRentalPage,
  })),
);
const CampaignPropertiesPage = lazyWithRetry(() =>
  import(/* webpackChunkName: "CampaignPropertiesPage" */ "src/pages/maria").then((module) => ({
    default: module.CampaignPropertiesPage,
  })),
);

const MariaRequestHowItWorksPage = lazyWithRetry(
  () => import(/* webpackChunkName: "MariaRequestHowItWorksPage" */ "src/pages/maria/CampaignHowItWorksPage"),
);

const MariaCampaignWelcomePage = lazyWithRetry(
  () => import(/* webpackChunkName: "MariaCampaignWelcomePage" */ "src/pages/maria/CampaignWelcomePage"),
);

const MariaRequestPage = lazyWithRetry(() => import(/* webpackChunkName: "MariaRequestPage" */ "src/pages/maria/requestForm"));

const CampaignApplicationsPage = lazyWithRetry(() =>
  import(/* webpackChunkName: "CampaignApplicationsPage" */ "src/pages/maria").then((module) => ({
    default: module.CampaignApplicationsPage,
  })),
);

const CampaignSettingsPage = lazyWithRetry(() =>
  import(/* webpackChunkName: "CampaignSettingsPage" */ "src/pages/maria").then((module) => ({
    default: module.CampaignSettingsPage,
  })),
);

const mariaRouter: RouteObject[] = [
  {
    path: "maria/",
    element: (
      <LoginRequiredWrapper>
        <CampaignPage />
      </LoginRequiredWrapper>
    ),
    children: [
      {
        index: true,
        element: (
          <LoginRequiredWrapper>
            <CampaignDashboardPage />
          </LoginRequiredWrapper>
        ),
      },
      {
        path: "how-it-works/",
        element: (
          <LoginRequiredWrapper>
            <MariaRequestHowItWorksPage />
          </LoginRequiredWrapper>
        ),
      },
      {
        path: "request/",
        element: (
          <LoginRequiredWrapper>
            <MariaCampaignWelcomePage />
          </LoginRequiredWrapper>
        ),
      },
      {
        path: "request/:id",
        element: (
          <LoginRequiredWrapper>
            <MariaRequestPage />
          </LoginRequiredWrapper>
        ),
      },
      {
        path: ":page/",
        element: (
          <LoginRequiredWrapper>
            <CampaignPage />
          </LoginRequiredWrapper>
        ),
      },
      {
        path: "campaign/:id/",
        element: (
          <LoginRequiredWrapper>
            <CampaignDetailPage />
          </LoginRequiredWrapper>
        ),
        children: [
          {
            index: true,
            element: (
              <LoginRequiredWrapper>
                <CampaignDetailOverview />
              </LoginRequiredWrapper>
            ),
          },
          {
            path: "properties/",
            element: (
              <LoginRequiredWrapper>
                <CampaignPropertiesPage />
              </LoginRequiredWrapper>
            ),
          },
          {
            path: "rent-market/",
            element: (
              <LoginRequiredWrapper>
                <CampaignRentalPage />
              </LoginRequiredWrapper>
            ),
          },
          {
            path: "applications/",
            element: (
              <LoginRequiredWrapper>
                <CampaignApplicationsPage />
              </LoginRequiredWrapper>
            ),
          },
          {
            path: "settings/",
            element: (
              <LoginRequiredWrapper>
                <CampaignSettingsPage />
              </LoginRequiredWrapper>
            ),
          },
        ],
      },
    ],
  },
];

export default mariaRouter;
